import { Link } from 'react-router-dom';

export default function BusinessIntelligencePage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-gradient-to-br from-indigo-600 to-purple-600 text-white py-20">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <Link 
            to="/"
            className="inline-flex items-center gap-2 text-white/90 hover:text-white mb-8 transition-colors whitespace-nowrap"
          >
            <i className="ri-arrow-left-line"></i>
            Back to home
          </Link>
          
          <div className="flex items-center gap-4 mb-6">
            <div className="w-16 h-16 rounded-xl bg-white/20 backdrop-blur-sm flex items-center justify-center">
              <i className="ri-database-2-line text-3xl"></i>
            </div>
            <h1 className="text-5xl font-bold">Business Intelligence</h1>
          </div>
          
          <p className="text-xl text-white/90 leading-relaxed">
            Access structured company and sector data that powers strategic decision-making.
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 lg:px-8 py-16">
        <div className="prose prose-lg max-w-none">
          <h2 className="text-3xl font-bold text-slate-900 mb-6">What is Business Intelligence?</h2>
          <p className="text-slate-600 leading-relaxed mb-8">
            Our Business Intelligence service provides you with access to comprehensive, structured data about companies, sectors, and markets. We transform raw data into actionable insights that empower your strategic decision-making. Whether you're evaluating potential partners, assessing market opportunities, or conducting due diligence, our BI solutions give you the intelligence you need to succeed.
          </p>

          <h2 className="text-3xl font-bold text-slate-900 mb-6">Key Features</h2>
          <div className="space-y-6 mb-12">
            <div className="flex gap-4">
              <div className="w-12 h-12 rounded-lg bg-purple-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-building-line text-xl text-purple-600"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-slate-900 mb-2">Company Data & Profiles</h3>
                <p className="text-slate-600 leading-relaxed">
                  Access detailed company information including financials, organizational structure, key personnel, and business activities across multiple sectors.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="w-12 h-12 rounded-lg bg-purple-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-stack-line text-xl text-purple-600"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-slate-900 mb-2">Sector Analysis</h3>
                <p className="text-slate-600 leading-relaxed">
                  Gain insights into sector performance, trends, key players, and market dynamics to identify opportunities and assess risks.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="w-12 h-12 rounded-lg bg-purple-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-dashboard-line text-xl text-purple-600"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-slate-900 mb-2">Custom Dashboards</h3>
                <p className="text-slate-600 leading-relaxed">
                  Visualize complex data through intuitive dashboards and reports tailored to your specific business needs and KPIs.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="w-12 h-12 rounded-lg bg-purple-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-refresh-line text-xl text-purple-600"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-slate-900 mb-2">Real-Time Data Updates</h3>
                <p className="text-slate-600 leading-relaxed">
                  Stay current with continuously updated data feeds that ensure you're always working with the latest information.
                </p>
              </div>
            </div>
          </div>

          <h2 className="text-3xl font-bold text-slate-900 mb-6">Benefits</h2>
          <ul className="space-y-3 mb-12">
            <li className="flex items-start gap-3">
              <i className="ri-check-line text-xl text-purple-600 mt-1"></i>
              <span className="text-slate-600">Make informed decisions backed by comprehensive data</span>
            </li>
            <li className="flex items-start gap-3">
              <i className="ri-check-line text-xl text-purple-600 mt-1"></i>
              <span className="text-slate-600">Identify trends and patterns that drive business growth</span>
            </li>
            <li className="flex items-start gap-3">
              <i className="ri-check-line text-xl text-purple-600 mt-1"></i>
              <span className="text-slate-600">Reduce research time with centralized, structured data</span>
            </li>
            <li className="flex items-start gap-3">
              <i className="ri-check-line text-xl text-purple-600 mt-1"></i>
              <span className="text-slate-600">Enhance due diligence and risk assessment processes</span>
            </li>
            <li className="flex items-start gap-3">
              <i className="ri-check-line text-xl text-purple-600 mt-1"></i>
              <span className="text-slate-600">Gain competitive advantage through superior market intelligence</span>
            </li>
          </ul>

          <div className="bg-slate-50 rounded-2xl p-8 mt-12">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Ready to Get Started?</h2>
            <p className="text-slate-600 mb-6">
              Unlock the power of data-driven decision-making with our comprehensive business intelligence solutions.
            </p>
            <Link 
              to="/"
              onClick={(e) => {
                e.preventDefault();
                window.REACT_APP_NAVIGATE('/');
                setTimeout(() => {
                  const element = document.getElementById('contact');
                  if (element) {
                    const offset = 80;
                    const elementPosition = element.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - offset;
                    window.scrollTo({
                      top: offsetPosition,
                      behavior: 'smooth'
                    });
                  }
                }, 100);
              }}
              className="inline-flex items-center gap-2 bg-purple-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-purple-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Contact Us
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
